import axios from "axios";
const jsonConfig = require("../../config.json");

const unSuppressCustomer = async (alertid,payload) => {
  try {
    const getAllResponse = await axios.put(jsonConfig.apiUrl + "unsuppress/"+alertid,payload, {
      headers: {
        "x-functions-key": jsonConfig.key,
      },
    });

    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default unSuppressCustomer;